import { Component, Input } from "@angular/core";

import { BaseSearchTabConfigModel } from "../../../../models/base-search-tab-config.model";

import { SearchResultsModel } from "../../models/search-results.model";

@Component({
    selector: "pcg-ng-directory-search-results-list-view",
    template: require('./directory-search-results-list-view.component.html')
})
export class DirectorySearchResultsListViewComponent {
    @Input()
    public searchConfig: BaseSearchTabConfigModel;

    @Input()
    public searchResult: SearchResultsModel;
}
